export default "__VITE_PUBLIC_ASSET__7af252b9__"